var ANIMATED_STYLE_PROPERTIES = ['borderBottomWidth', 'borderTopWidth', 'paddingBottom', 'paddingTop'];
var ELEMENT_TRANSITION = function (duration) { return "all ".concat(duration, "ms ease-in-out"); };
var ELEMENT_TRANSITION_PROPERTY = 'border, max-height, padding';
var COLLAPSED_STYLE = {
    borderBottomWidth: '0px',
    borderTopWidth: '0px',
    maxHeight: '0px',
    overflow: 'hidden',
    paddingBottom: '0px',
    paddingTop: '0px',
};
var prepareTransition = function (style, duration) {
    style.transition = ELEMENT_TRANSITION(duration);
    style.transitionProperty = ELEMENT_TRANSITION_PROPERTY;
};

export { ANIMATED_STYLE_PROPERTIES, COLLAPSED_STYLE, ELEMENT_TRANSITION, ELEMENT_TRANSITION_PROPERTY, prepareTransition };
//# sourceMappingURL=useCollapsible.utils.esm.js.map
